import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { LoginService } from '../services/login-service/login.service';
import { filterSelectionState } from '../routes/search-cars-component/search-cars.helper.consts';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable()
export class CanActivateSearchGuard implements CanActivate {
  constructor(
    private router: Router,
    private loginService: LoginService
  ) {}

  hasAccessToRailcarSearch = false;

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const rslt = this.loginService.isSessionValid();
    const storedEmail = localStorage.getItem('userEmail');

    if (!rslt && !storedEmail) {
      this.router.navigate(['/']);
      this.loginService.setUser(null);
      return false;
    }

    if (storedEmail) {
      return this.loginService.isTrinUser(storedEmail).pipe(
        map((isTrinUser: boolean) => {
          this.hasAccessToRailcarSearch = isTrinUser;

          if (!isTrinUser) {
            this.router.navigate(['/']); // Redirect unauthorized users
            return false;
          }

          if (route.queryParams['val'] !== undefined) {
            return this.decodeQueryParams(route);
          }

          return true;
        }),
        catchError(() => {
          this.hasAccessToRailcarSearch = false;
          this.router.navigate(['/']);
          return of(false);
        })
      );
    }

    if (route.queryParams['val'] !== undefined) {
      return this.decodeQueryParams(route);
    }

    return true;
  }

  decodeQueryParams(route: any) {
    if (route.queryParams.val) {
      let val = this.decodeBase64(route.queryParams.val);
      val = JSON.parse(val);
      sessionStorage.setItem(filterSelectionState, JSON.stringify(val));
      this.router.navigate(['/search-inventory/search-cars']);
    } else {
      return true;
    }
    return true;
  }
  decodeBase64(encodedString: string): string {
    if (encodedString) {
      try {
        return atob(encodedString);
      } catch (error) {
        console.error('Error decoding Base64:', error);
        return '';
      }
    }
    return '';
  }
}
